import React, { forwardRef } from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import theme from 'shared/styles/theme';

const BodySmBoldText = forwardRef<Text, TextProps>(
  ({ children, style, ...props }, ref) => {
    return (
      <Text ref={ref} style={[styles.bodySmBoldText, style]} {...props}>
        {children}
      </Text>
    );
  },
);

const styles = StyleSheet.create({
  bodySmBoldText: {
    ...theme.typography.body.smBold,
    color: theme.color.text.primary,
  },
});

export default BodySmBoldText;
